export default "__VITE_ASSET__CNzI7C_L__"